import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const estafetaData = {
  key: 'ESTAFETA',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'API KEY',
          label: 'Ej: api_key_example',
          keyName: 'apiKey',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu API KEY',
          validationSchema: Yup.string().required('Ingresa el campo API KEY')
        },
        {
          title: 'USER ID',
          label: 'Ej: user_id_example',
          keyName: 'userId',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu USER ID',
          validationSchema: Yup.string().required('Ingresa el campo USER ID')
        },
        {
          title: 'PASSWORD',
          label: 'Ej: password_example',
          keyName: 'password',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu PASSWORD',
          validationSchema: Yup.string().required('Ingresa el campo PASSWORD')
        },
        {
          title: 'USERNAME',
          label: 'Ej: user_name_example',
          keyName: 'username',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu USERNAME',
          validationSchema: Yup.string().required('Ingresa el campo USERNAME')
        },
        {
          title: 'CLIENT SECRET',
          label: 'Ej: client_secret_example',
          keyName: 'clientSecret',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CLIENT SECRET',
          validationSchema: Yup.string().required(
            'Ingresa el campo CLIENT SECRET'
          )
        },
        {
          title: 'SUBSCRIBER ID',
          label: 'Ej: subscriber_id_example',
          keyName: 'subscriberId',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu SUBSCRIBER ID',
          validationSchema: Yup.string().required(
            'Ingresa el campo SUBSCRIBER ID'
          )
        },
        {
          title: 'CUSTOMER NUMBER',
          label: 'Ej: 0000000',
          keyName: 'customerNumber',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu CUSTOMER NUMBER',
          validationSchema: Yup.string().required(
            'Ingresa el campo CUSTOMER NUMBER'
          )
        }
      ]
    }
  ]
};

export default estafetaData;
